// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Guernsey from '../_raw/flag/icon_flag_guernsey.png';

export default () => <img src={Guernsey} alt="Guernsey" />;
